import { type ReactNode } from 'react'
import {
  SideSheet,
  SideSheetHostView,
  SideSheetMain,
} from '@/components/SideSheet'
import { useScrollOffsets } from '@/hooks/element-hooks'
import { BookkeepingManagerHeader } from '@/features/admin/bookkeeping/components/BookkeepingManagerHeader'
import { ContentLayout } from '@/components/ContentLayout'
import { TableHost } from '@/components/Table'
import { TableScroller } from '@/components/Table/TableScroller'
import { TableSearchbar } from '@/components/TableSearchbar'
import { BookkeepingManagerTableTotal } from '@/features/admin/bookkeeping/components/BookkeepingManagerTableTotal'
import { Sandwich, SandwichBun } from '@/components/Sandwich'

import styles from './BookkeepingManager.module.css'

export interface BookkeepingManagerProps {
  heading: ReactNode
  isSideSheetVisible: boolean
  actionFilter: ReactNode
  total: number
  searchText: string
  onSearchTextChange: (text: string) => void
  table: ReactNode
  details: ReactNode
}

export function BookkeepingManager({
  heading,
  isSideSheetVisible,
  actionFilter,
  total,
  searchText,
  onSearchTextChange,
  table,
  details,
}: BookkeepingManagerProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()

  return (
    <div className={styles.root} ref={scrollRef}>
      <BookkeepingManagerHeader scrollOffset={scrollOffset}>
        {heading}
      </BookkeepingManagerHeader>
      <SideSheetHostView sheetVisible={isSideSheetVisible}>
        <SideSheetMain>
          <Sandwich stretch>
            <SandwichBun>{actionFilter}</SandwichBun>
            <BookkeepingManagerTableTotal total={total} />
            <ContentLayout>
              <TableHost>
                <TableSearchbar
                  searchText={searchText}
                  onSearchTextChange={onSearchTextChange}
                />
                <TableScroller>{table}</TableScroller>
              </TableHost>
            </ContentLayout>
          </Sandwich>
        </SideSheetMain>
        <SideSheet>{details}</SideSheet>
      </SideSheetHostView>
    </div>
  )
}
